module.exports = __webpack_public_path__ + "static/parade-2019-house03-43c32d2212f834b5e250bbf4bad1e5c1.jpg";